export enum AuthenticationProvider {
  ten = 'ten',
  visa_lac = 'visalac',
  creditsaison = 'creditsaison',
  creditsaisondiamond = 'creditsaison-diamond',
}
